'use client'
import { faClockRotateLeft, faCreditCard } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Style from "@/lib/style";
import Details from "@/lib/programContent";

type Props = {
  programName: string;
};

export default function StudyPlanDescription(props: Props) {
  const { programName } = props;
  const matchedStyle = Style.find(style => style.title === programName);
  const planDescription = Details[programName].planDescription;

  return (
    <section className="mb-24">
      <div className="text-center mx-auto py-2 bigscreen-responsive xl:mt-44 md:px-0 flex flex-col items-center relative">
        <div className={`border-[5px] ${matchedStyle?.colors?.[0].border} rounded-full p-1.5`}>
          <img src="/images/chefsClase.jpg" alt="Chefs" className="rounded-full " />
        </div>
        <p className="text-lg max-w-md px-8 mt-8 md:px-2 md:text-2xl md:max-w-3xl xl:max-w-lg xl:px-0 xl:py-0 xl:-mx-24 font-bold">
          Te preparamos para <span className={matchedStyle?.colors?.[0].textColor}>liderar</span> en la industria
        </p>
        <div className="text-xs max-w-sm py-4 px-8 md:px-2 md:text-lg md:max-w-3xl xl:px-0 xl:py-4 xl:-mx-24" dangerouslySetInnerHTML={{ __html: planDescription.content }} />
      </div>
    </section>
  );
}